<template>
	<!-- 签到首页 -->
	<div>
		<!-- <van-nav-bar
			title="今日推广注册"
			left-arrow
			@click-left="onClickLeft"/> -->
		<div class="">
			<div class="list">
				<div class="litem f-ac f-jsb">
					<div class="tit f-ac">注册分享：{{list.length}}/10</div>
					<div class="not-odr">
						<div>{{list.length>=10?"已完成":"未完成"}}</div>
					</div>
				</div>
				<div class="litem" v-for="(item,index) in list" :key="index">
					<div class="t">会员ID：{{item.userId}}</div>
					<div class="f-ac f-jsb">
						<div v-text="timeInit(item.createTime)"></div>
						<div>贡献值+{{comtribAmt}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { Toast } from 'vant';
	export default {
	  name: "",
	  data() {
	    return {
		  isload:false,
		  dataSource: [],
		  navList:[
			  {nm:'已下单会员',id:0},
			  {nm:'未下单会员',id:1},
		  ],
		  userId:0,
		  list:[],
		  comtribAmt:0
	    };
	  },
	  components:{ },
	  created() {
		  this.userId = this.$route.query.userId;
		  this.getList();
	  },
	  mounted() {
	  	document.querySelector('body').setAttribute('style', 'background-color:#ffffff');
		document.querySelector('title').innerText = '今日推广注册';
	  },
	methods: {
		navChange(res){
			console.log(res);
			return true;
		},
		onClickLeft(){
			
			this.$router.push('/');
		},
		async getList(){
			Toast.loading({ message: '加载中...',forbidClick: true,loadingType: 'spinner'});
			let res = await this.$axios.get(`common/v1/system/selShareContribs?userId=${this.userId}`);
			if(res.data.success){
				Toast.clear();
				console.log('res.data.data',res.data.data);
				this.list = res.data.data.detail;
				this.comtribAmt = res.data.data.comtribAmt;
			}else{
				Toast.clear();
				Toast(res.data.msg);
			}
		},
		timeInit(t){
			return this.$util.dateFormat(new Date(t),'yyyy-MM-dd hh:mm:ss')
		}
	}
};
</script>

<style lang="less" scoped>
	.list{
		overflow-y: scroll;
		height: calc(100% - 110px);//80vh;
		.litem{
			border: 0.0625rem solid #F8F8F8;
			padding: 0.625rem 0.9375rem;
			margin: 0.625rem 0.625rem 0;
			border-radius: 0.2875rem;
			.t{
				margin-bottom: 0.625rem;
			}
			.tit{
				font-size: 18px;
				font-weight: 700;
			}
		}
		.not-odr{
			width: 3.125rem;
			height: 3.125rem;
			display: flex;
			justify-content: center;
			align-items: center;
			border: 1px solid #F8F8F8;
			border-radius: 100px;
			font-size: 0.8125rem;
		}
	}
</style>


// WEBPACK FOOTER //
// src/page/integral/user-share.vue